const DiscountAnnouncement = () => {
  return (
    <div className="sm:hidden bg-primary-darker w-full flex flex-col items-center justify-center py-6 mt-[20px]">
      <p className="font-poppins font-extrabold text-[26px] leading-none tracking-[-0.01em] text-white text-center capitalize">
        — 50%OFF —
      </p>
      <p className="font-poppins text-white text-[14px] mt-2">on all tshirts</p>
    </div>
  );
};

export default DiscountAnnouncement;
